import React from 'react'

const PATH_D = 'M4.16667 18.3333C3.70833 18.3333 3.31597 18.1701 2.98958 17.8437C2.66319 17.5174 2.5 17.125 '
  + '2.5 16.6667V5C2.5 4.54167 2.66319 4.14931 2.98958 3.82292C3.31597 3.49653 3.70833 3.33333 4.16667 '
  + '3.33333H5V2.5C5 2.26389 5.07986 2.06597 5.23958 1.90625C5.39931 1.74653 5.59722 1.66667 5.83333 '
  + '1.66667C6.06944 1.66667 6.26736 1.74653 6.42708 1.90625C6.58681 2.06597 6.66667 2.26389 6.66667 '
  + '2.5V3.33333H13.3333V2.5C13.3333 2.26389 13.4132 2.06597 13.5729 1.90625C13.7326 1.74653 13.9306 '
  + '1.66667 14.1667 1.66667C14.4028 1.66667 14.6007 1.74653 14.7604 1.90625C14.9201 2.06597 15 2.26389 '
  + '15 2.5V3.33333H15.8333C16.2917 3.33333 16.684 3.49653 17.0104 3.82292C17.3368 4.14931 17.5 4.54167 '
  + '17.5 5V16.6667C17.5 17.125 17.3368 17.5174 17.0104 17.8437C16.684 18.1701 16.2917 18.3333 15.8333 '
  + '18.3333H4.16667ZM4.16667 16.6667H15.8333V8.33333H4.16667V16.6667ZM4.16667 6.66667H15.8333V5H4.16667'
  + 'V6.66667Z'

const CalendarIcon = () => (
  <svg
    aria-hidden="true"
    fill="currentColor"
    height="1em"
    viewBox="0 0 20 20"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d={PATH_D} />
  </svg>
)

export default CalendarIcon
